import { useCallback, useEffect, useState } from 'react'
import { getQuestionnaireBuildingApi } from '../api/requester'

export const useBuilding = (initialBuilding) => {
  const [building, setBuilding] = useState(initialBuilding)

  const getBuilding = useCallback(
    async (id) => {
      try {
        const res = await getQuestionnaireBuildingApi(id)
        setBuilding(res.data)
      } catch (error) {
        setBuilding(initialBuilding)
      }
    },
    [initialBuilding]
  )

  useEffect(() => {
    if (initialBuilding && !initialBuilding?.building_structure) {
      getBuilding(initialBuilding?.id)
    } else {
      setBuilding(initialBuilding)
    }
  }, [initialBuilding, getBuilding])

  return [building, setBuilding]
}
